export const QUERY_ROOT_NAME = 'query_root';

export const BADGE_CACHE_FIELDS = [
  'badge',
  'badge_aggregate',
  'badge_by_pk',
  'relevant_badge',
  'relevant_badge_aggregate',
];

export const ORGANIZATION_PEOPLE_CACHE_FIELDS = [
  'event_by_pk',
  'event_person',
  'event_person_aggregate',
  'event_person_member_type',
  'person_by_pk',
];

export const TEAM_PEOPLE_CACHE_FIELDS = [
  'event',
  'event_by_pk',
  'person_team',
  'person_team_aggregate',
  'team',
  'team_by_pk',
];

export const EVENT_LIST_CACHE_FIELDS = [
  'event',
  'event_home',
  'event_date_range',
];

export const EVENT_TEAM_CACHE_FIELDS = [
  'event',
  'event_by_pk',
  'event_team',
  'event_team_aggregate',
  'event_team_management',
  'person_by_pk',
  'team',
  'team_by_pk',
  'event_person',
  'event_person_aggregate',
];

export const EVENT_PERSON_CACHE_FIELDS = [
  ...EVENT_LIST_CACHE_FIELDS,
  'event_by_pk',
  ...ORGANIZATION_PEOPLE_CACHE_FIELDS,
  'person',
  'person_aggregate',
];

export const BADGE_ASSIGNMENT_CACHE_FIELDS = [
  'badge_assignee',
  'badge_assignee_aggregate',
  'badge_assignee_by_pk',
  'badge_by_pk',
  'person',
  'person_aggregate',
  'person_by_pk',
  'person_team',
  'person_team_aggregate',
  'relevant_badge',
  'relevant_badge_aggregate',
  'team_by_pk',
  ...ORGANIZATION_PEOPLE_CACHE_FIELDS,
];
